import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CostCenterGroupAction from "../../Actions/CostCenterGroupAction";
import costCenterGroupStore from "../../Stores/CostCenterGroupStores";
import CostCenterGroupConstants from "../../Constants/CostCenterGroupConstants";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import AddIcon from "@mui/icons-material/Add";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import CommonSearchBar from "../ReusableComponent/CommonSearchBar";
import { customizeFilter } from "../FilterOptions/CustomizeFilter";
import AddCostCenterGroup from "./AddCostCenterGroup";
import commonUtils from "../../helpers/commonUtils";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import { Button } from "@mui/material";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import { PageHeader } from "../MuiOverRideComponent/PageHeader";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
const CostCenterGroup = (props) => {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [costCentergrpList, setcostCentergrpList] = useState(null);
  const [rescostCentergrpList, setRescostCentergrpList] = useState([]);
  const [costCentergrpDetails, setCostCentergrpDetails] = useState("");
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const columns = [
    {
      field: "costGroup",
      headerName: localization.costCenterGroup,
      hideable: false,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    // { field: "id", headerName: "Id" },
  ];
  const closeAddEditCostCenterGrpPopUpCallback = () => {
    setCostCentergrpDetails("");
  };
  const handleAdd = () => {
    setCostCentergrpDetails("");
  };
  const handleEdit = (row) => {
    setCostCentergrpDetails(row);
  };

  const handleDelete = (row) => {
    const _idList = [];
    if (Array.isArray(row)) {
      row.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(row.id);
    }
    deleteCostCenterGrpCallback(_idList);
  };

  const operations = {
    RowOperationList: [
      {
        label: "Edit",
        component: <RenderEditButton />,
        onClick: handleEdit,
      },
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
    GridToolBarAction: [
      {
        label: "Add",
        component: <RenderAddCostcenterGrp />,
        onClick: handleAdd,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
  };

  useEffect(() => {
    getCostCenterGroup();
    function geCostCenterGroupSuccess() {
      const res = costCenterGroupStore.getResult();

      if (res.length > 0) {
        setRescostCentergrpList(res);
        setcostCentergrpList(res);
      } else {
        setRescostCentergrpList([]);
        setcostCentergrpList([]);
      }
      setGlobalSpinner(false);
    }
    function geCostCenterGroupFailure() {
      const res = costCenterGroupStore.getResult();
      setGlobalSpinner(false);
    }
    costCenterGroupStore.addChangeListener(
      CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_SUCCESS,
      geCostCenterGroupSuccess
    );
    costCenterGroupStore.addChangeListener(
      CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_FAILURE,
      geCostCenterGroupFailure
    );
    return () => {
      costCenterGroupStore.removeChangeListener(
        CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_SUCCESS,
        geCostCenterGroupSuccess
      );
      costCenterGroupStore.removeChangeListener(
        CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_FAILURE,
        geCostCenterGroupFailure
      );
    };
  }, []);

  //------------------------Add or update cost center grp start ----------------------
  useEffect(() => {
    function addorUpdateCostCenterGroupSuccess() {
      const res = costCenterGroupStore.getResult();

      if (res) {
        commonUtils.hideModalPopUp("addCostCenterGroupModalClose");
        toast.success(
          commonUtils.getIsEdit()
            ? localization.costCenterGrpEditedSuccessfully
            : localization.costCenterGrpAddSuccessfully
        );
      } else {
        toast.error(res);
      }
      getCostCenterGroup();
    }

    function addorUpdateCostCenterGroupFailure() {
      const res = costCenterGroupStore.getResult();

      toast.error(res);
      setGlobalSpinner(false);
    }

    costCenterGroupStore.addChangeListener(
      CostCenterGroupConstants.ADDORUPDATE_COST_CENTER_GROUP_SUCCESS,
      addorUpdateCostCenterGroupSuccess
    );

    costCenterGroupStore.addChangeListener(
      CostCenterGroupConstants.ADDORUPDATE_COST_CENTER_GROUP_FAILURE,
      addorUpdateCostCenterGroupFailure
    );

    return () => {
      costCenterGroupStore.removeChangeListener(
        CostCenterGroupConstants.ADDORUPDATE_COST_CENTER_GROUP_SUCCESS,
        addorUpdateCostCenterGroupSuccess
      );

      costCenterGroupStore.removeChangeListener(
        CostCenterGroupConstants.ADDORUPDATE_COST_CENTER_GROUP_FAILURE,
        addorUpdateCostCenterGroupFailure
      );
    };
  }, []);

  //------------------------Delete Cost center grp start ----------------------
  useEffect(() => {
    function costCenterGrpDeleteSuccess() {
      const res = costCenterGroupStore.getResult();
      if (res.length === 0) {
        toast.success(localization.costCenterGroupDeletedSuccessfully);
      } else {
        res.forEach((item) => toast.error(item));
      }
      setcostCentergrpList(null);

      getCostCenterGroup();
    }
    function costCenterGrpFailure() {
      const res = costCenterGroupStore.getResult();

      toast.error(res);
      setGlobalSpinner(false);
    }

    costCenterGroupStore.addChangeListener(
      CostCenterGroupConstants.DELETE_COST_CENTER_GROUP_SUCCESS,
      costCenterGrpDeleteSuccess
    );

    costCenterGroupStore.addChangeListener(
      CostCenterGroupConstants.DELETE_COST_CENTER_GROUP_FAILURE,
      costCenterGrpFailure
    );

    return () => {
      costCenterGroupStore.removeChangeListener(
        CostCenterGroupConstants.DELETE_COST_CENTER_GROUP_SUCCESS,
        costCenterGrpDeleteSuccess
      );

      costCenterGroupStore.removeChangeListener(
        CostCenterGroupConstants.DELETE_COST_CENTER_GROUP_FAILURE,
        costCenterGrpFailure
      );
    };
  }, []);

  function getCostCenterGroup() {
    setGlobalSpinner(true);
    CostCenterGroupAction.getCostCenterGroupList();
  }

  function RenderEditButton() {
    return (
      <>
        <Button
          id="editCostCenterGrpTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineEdit />}
          data-toggle="modal"
          data-target="#addCostCenterGrp"
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }

  function RenderDeleteButton(props) {
    const id = props.costCenterID;
    return (
      <>
        <Button
          id="deleteCostCenterGrpTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }

  function RenderAddCostcenterGrp() {
    return (
      <>
        <Button
          id="addCostCenterGrp"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AddIcon />}
          data-toggle="modal"
          data-target="#addCostCenterGrp"
        >
          {localization.add}
        </Button>
      </>
    );
  }

  function deleteCostCenterGrpCallback(id) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.areYouSureYouWantToCostCenterGroup);
    setCallbackData(id);
    setEventType("DELETE_COST_CENTER_GROUP");
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_COST_CENTER_GROUP":
          setGlobalSpinner(true);
          const res = CostCenterGroupAction.deleteCostCenterGroup(data);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => handleEdit(params.row)}
        data-toggle="modal"
        data-target="#addCostCenterGrp"
      />
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />
    );

    return _acionList;
  }
  return (
    <>
      <AddCostCenterGroup
        costCentergrpDetails={costCentergrpDetails}
        closeAddEditCostCenterGrpPopUpCallback={
          closeAddEditCostCenterGrpPopUpCallback
        }
      />
      <div className="w-100 h-100" id="content">
        {costCentergrpList && (
          <CustomDataGrid
            Title={
              localization.orgSetting + " / " + localization.costCenterGroup
            }
            columns={columns}
            rows={costCentergrpList}
            operations={operations}
            onAdd={handleAdd}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={["costGroup"]}
            showCheckBox={true}
            gridTableHeight={"dataGridLarge"}
          />
        )}
      </div>

      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};

export default CostCenterGroup;
